import { ira } from '@store/modules/ira';
import { RouteConfig } from 'vue-router';

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const iraVerifyRoutes: RouteConfig = {
	path: `/ira/verify`,
	name: 'ira-verify',
	beforeEnter: async (to, from, next) => {
		ira.UPDATE_FLOW('VERIFY');
		if (!ira.dataRetrieved) {
			try {
				await ira.getVerifyFlowInfo();
			} catch {}
		}
		await next();
	},
	component: () => import(/* webpackChunkName: "ira-verify-start" */ '@views/ira/verify/ira-verify-start.vue'),
	children: [
		{
			path: `documents`,
			name: 'ira-verify-documents',
			beforeEnter: async (to, from, next) => {
				if (ira.verificationStatus === 'AWAITING_DOCUMENTATION') {
					await next();
				} else {
					await next({ name: 'ira-verify-success', replace: true });
				}
			},
			component: () => import(/* webpackChunkName: "ira-documents" */ '@views/ira/signup/ira-documents.vue')
		},
		{
			path: `success`,
			name: 'ira-verify-success',
			component: () =>
				import(/* webpackChunkName: "ira-verify-success" */ '@views/ira/verify/ira-verify-success.vue')
		}
	]
};

export default iraVerifyRoutes;
